import { useEffect, useState } from 'react';
import { publicGallery, publicAntiques, publicArtists } from './api';

const cache = { gallery: null, antiques: null, artists: null };

export const useGallery = () => {
  const [data, setData] = useState(cache.gallery || []);
  const [loading, setLoading] = useState(!cache.gallery);
  useEffect(() => {
    publicGallery().then((r) => { cache.gallery = r.data; setData(r.data); }).finally(() => setLoading(false));
  }, []);
  return { items: data, loading };
};

export const useAntiques = () => {
  const [data, setData] = useState(cache.antiques || []);
  const [loading, setLoading] = useState(!cache.antiques);
  useEffect(() => {
    publicAntiques().then((r) => { cache.antiques = r.data; setData(r.data); }).finally(() => setLoading(false));
  }, []);
  return { items: data, loading };
};

export const useArtists = () => {
  const [data, setData] = useState(cache.artists || []);
  const [loading, setLoading] = useState(!cache.artists);
  useEffect(() => {
    publicArtists().then((r) => { cache.artists = r.data; setData(r.data); }).finally(() => setLoading(false));
  }, []);
  return { items: data, loading };
};

// Invalidate cached data — call this from the admin save handlers if you ever
// want public pages to refetch live in the same session.
export const invalidateCache = () => { cache.gallery = cache.antiques = cache.artists = null; };
